"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preferenceData = exports.TXN_REG_PREF_FF = void 0;
exports.TXN_REG_PREF_FF = {
    prefEditDownloaded: 'prefEditDownloaded',
    prefDeleteDownloaded: 'prefDeleteDownloaded',
    prefAutoSaveEditedTxns: 'prefAutoSaveEditedTransactions',
    prefMoneyInOutColumn: 'prefMoneyInOutColumn',
    prefAutoSearch: 'prefAutoSearch',
    prefWrapText: 'prefWrapText',
    prefLongCatName: 'prefLongCatName',
    prefCurrencySymbolTxnList: 'prefCurrencySymbolTransactionList',
    prefNewTxnEntry: 'prefNewTransactionEntry',
    prefColoredAccounts: 'prefColoredAccounts',
};
exports.preferenceData = [
    {
        label: 'Allow editing amounts of downloaded transactions',
        field: 'editDownloaded',
        id: 'txn-pref-edit-downloaded-txns',
        fflag: exports.TXN_REG_PREF_FF.prefEditDownloaded,
    },
    {
        label: 'Allow deletion of downloaded transactions',
        field: 'deleteDownloaded',
        id: 'txn-pref-delete-downloaded-txns',
        fflag: exports.TXN_REG_PREF_FF.prefDeleteDownloaded,
    },
    {
        label: 'Automatically save edited transactions',
        field: 'autoSave',
        id: 'txn-pref-auto-save-edited-txns',
        fflag: exports.TXN_REG_PREF_FF.prefAutoSaveEditedTxns,
    },
    {
        label: 'Show separate Money In and Money Out columns',
        field: 'doubleAmounts',
        id: 'txn-pref-show-money-in-money-out',
        fflag: exports.TXN_REG_PREF_FF.prefMoneyInOutColumn,
    },
    {
        label: 'Automatically search in register as you type in search field',
        field: 'autoSearch',
        id: 'txn-pref-auto-search',
        fflag: exports.TXN_REG_PREF_FF.prefAutoSearch,
    },
    {
        label: 'Wrap text in transaction list fields',
        field: 'wrapText',
        id: 'txn-pref-wrap-text-in-txn-field',
        fflag: exports.TXN_REG_PREF_FF.prefWrapText,
    },
    {
        label: 'Show long form of category names (show full path with parent names)',
        field: 'longCats',
        id: 'txn-pref-show-long-category-names',
        fflag: exports.TXN_REG_PREF_FF.prefLongCatName,
    },
    {
        label: 'Show currency symbol on amounts in the transaction list',
        field: 'showCurrencySymbol',
        id: 'txn-pref-show-currency-symbol-on-amounts',
        fflag: exports.TXN_REG_PREF_FF.prefCurrencySymbolTxnList,
    },
    {
        label: 'After adding a new transaction include new transaction entry above all existing transactions',
        field: 'continuousCreate',
        id: 'txn-pref-new-txn-entry-above-txns',
        fflag: exports.TXN_REG_PREF_FF.prefNewTxnEntry,
    },
    {
        label: 'Show colored icon in transaction list instead of full account name',
        field: 'showAccountColors',
        id: 'txn-pref-show-account-colors',
        fflag: exports.TXN_REG_PREF_FF.prefColoredAccounts,
    },
];
